<div class="aems-card m-b-12">
  <p class="mds-content"><strong>Attachments</strong></p>
  <p class="subtext">Up to 20 attachments can be added. Only images,pdf and doc files are supported. Maximum file size : 5MB</p>
  <hr class="m-b-16" />
  <app-file-upload
    [parentForm]="attachmentForm"
    [shopCode]="shopCode()"
    [workOrderMode]="workOrderMode()"
    type="full"
    [maxFiles]="20"
    [inputFiles]="files"
    [inspectionDetailsWithLine]="inspectionDetailsForUpload"
    (inspectionDetailsWithLineAfterUserSelectionDoneEvent)="onInspectionImageDelete($event)">
  </app-file-upload>
</div>
